"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
exports.LunarPlanningOffice = void 0;
var CardName_1 = require("../../CardName");
var Tags_1 = require("../Tags");
var PreludeCard_1 = require("../prelude/PreludeCard");
var DrawCards_1 = require("../../deferredActions/DrawCards");
var CardRenderer_1 = require("../render/CardRenderer");
var LunarPlanningOffice = (function (_super) {
    __extends(LunarPlanningOffice, _super);
    function LunarPlanningOffice() {
        return _super.call(this, {
            name: CardName_1.CardName.LUNAR_PlANNING_OFFICE,
            tags: [Tags_1.Tags.MOON, Tags_1.Tags.BUILDING],
            metadata: {
                description: 'Draw 2 cards with Moon tag. Gain 6 steel.',
                cardNumber: '',
                renderData: CardRenderer_1.CardRenderer.builder(function (b) {
                    b.cards(2).secondaryTag(Tags_1.Tags.MOON).br.steel(6);
                }),
            },
        }) || this;
    }
    LunarPlanningOffice.prototype.play = function (player) {
        player.steel += 6;
        player.game.defer(DrawCards_1.DrawCards.keepAll(player, 2, { tag: Tags_1.Tags.MOON }));
        return undefined;
    };
    return LunarPlanningOffice;
}(PreludeCard_1.PreludeCard));
exports.LunarPlanningOffice = LunarPlanningOffice;
//# sourceMappingURL=LunarPlanningOffice.js.map